var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"Slider"},[_c('div',{staticClass:"track"},[_c('div',{staticClass:"progress",style:({ width: ((_vm.value * 100) + "%") })})]),_c('div',{staticClass:"knob",style:({ left: ("calc(" + (_vm.value * 100) + "% - 0.8em)") })})])}
var staticRenderFns = []

export { render, staticRenderFns }